export enum EProjectEnvironment {
  RELEASE_SIT = 'RELEASE-SIT',
  SIT = 'SIT',
  UAT = 'UAT',
  PROD = 'PROD'
}

export enum ENativeProjectEnvironment {
  RELEASE_SIT = 'release-sit',
  SIT = 'sit',
  UAT = 'uat',
  PROD = 'prod'
}

export enum EProjectPlatform {
  WEB = 'web',
  NATIVE = 'native'
}

export interface IBaseConfigs {
  baseURL: string;
  chartDomain: string;
  platform: EProjectPlatform;
  routePathPrefix: string;
  socketPathPrefix: string;
  environment?: string;
}
